import {
	Component,
	OnInit,
	Renderer2,
	PLATFORM_ID,
	HostListener,
	ElementRef,
	ViewChild,
} from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import {
	FormControl,
	FormGroup,
	FormBuilder,
	Validators,
	NgForm,
} from '@angular/forms';
import { OwlOptions } from 'ngx-owl-carousel-o';
declare var $: any;
// Services
import { PageService } from '../providers/page/page.service';

import { HttpClient } from '@angular/common/http';
import { ProjectService } from '../providers/project/project.service';
import {
	ModalDismissReasons,
	NgbModal,
	NgbActiveModal,
} from '@ng-bootstrap/ng-bootstrap';
import { PaymentsService } from '../providers/payments/payments.service';
// import { SpinalThreeService } from '../providers/SplineThree/spinal-three.service';
import { ReferralService } from '../providers/referral/referral.service';
import Swal from 'sweetalert2';
import {
	SearchCountryField,
	TooltipLabel,
	CountryISO,
} from 'ngx-intl-tel-input';
import { LazyLoaderService } from '../services/lazy-loader.service';
 

@Component({
	selector: 'app-website',
	templateUrl: './website.component.html',
	styleUrls: ['./website.component.scss'],
})
export class WebsiteComponent implements OnInit {
	@ViewChild('canvas', { static: true })
	containerRef!: ElementRef<HTMLDivElement>;
	baseUrl: any;
	spline: any;
	imagepath: any;
	currentPage: number = 1;
	allprojects: any = [];
	currentLimit: number = 24;
	// recent work slider
	recentoptions: OwlOptions = {
		loop: true,
		autoplay: true,
		mouseDrag: true,
		touchDrag: true,
		pullDrag: true,
		dots: false,
		navSpeed: 700,
		navText: ['', ''],
		margin: 14,
		responsive: {
			0: {
				items: 1,
			},
			480: {
				items: 1,
			},
			740: {
				items: 3,
			},
			940: {
				items: 4,
			},
		},
		nav: false,
	};
	clientslider: OwlOptions = {
		loop: true,
		autoplay: true,
		mouseDrag: true,
		touchDrag: false,
		pullDrag: false,
		dots: false,
		// navSpeed: 0,
		slideTransition: 'linear',
		autoplaySpeed: 3000,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
		// smartSpeed: 0,
		nav: false,
		center: false,
		navText: [
			'<i class="fas fa-arrow-left"></i>',
			'<i class="fas fa-arrow-right"></i>',
		],
		margin: 14,
		responsive: {
			0: {
				items: 2,
			},
			480: {
				items: 4,
			},
			740: {
				items: 4,
			},
			940: {
				items: 7,
			},
		},
	};
	sectionWidth: number = 10; // Initial height
	@HostListener('window:scroll', ['$event'])
	onScroll(event: Event): void {
		const scrollTop = window.scrollY || document.documentElement.scrollTop;

		// Adjust height and font size based on scroll position
		this.sectionWidth = Math.min(100, 50 + scrollTop / 10); // Max height: 100px
	}
	closeResult = '';
	modalReference = null;
	paymentForm: FormGroup;
	submitted: boolean = false;
	paymentData: any;

	formData = {
		name: '',
		email: '',
		contact: '',
		rname: '',
		remail: '',
		rcontact: '',
	};

	successMessage = '';
	errorMessage = '';
	isSubmitting = false;
	isLoading = false; // Loading indicator flag
	referralForm: FormGroup;
	isContactSame: boolean = false;
	isEmailSame: boolean = false;
	SearchCountryField = SearchCountryField;
	TooltipLabel = TooltipLabel;
	CountryISO = CountryISO;
	preferredCountries: CountryISO[] = [
		CountryISO.India,
		CountryISO.UnitedStates,
		CountryISO.UnitedKingdom,
		CountryISO.UnitedArabEmirates,
	];
	separateDialCode = false;
	isPaymentSubmitted: boolean = false;
	constructor(
		private renderer: Renderer2,
		private referralService: ReferralService,
		private pageservice: PageService,
		private metaTagService: Meta,
		private titleService: Title,
		private lazyLoader: LazyLoaderService,

		// private splineThreeService: SpinalThreeService,
		private formBuilder: FormBuilder,
		private readonly http: HttpClient,
		private projectservice: ProjectService,
		private modalService: NgbModal,
		private activeModal: NgbActiveModal,
		public payementservice: PaymentsService
	) {
		this.baseUrl = environment.baseUrl + '/assets';
		this.imagepath = environment.backendUrl + '/public/';
		this.get_PageMeta();
		this.get_AllProjects();
	}

	ngOnInit(): void {

		
		// const canvas = document.getElementById('canvas') as HTMLCanvasElement;
		// this.spline = new Application(canvas);
		// this.spline.load(
		// 	'https://prod.spline.design/bIYBHmJWoLbmwWUk/scene.splinecode'
		// );
		// if (this.containerRef && this.containerRef.nativeElement) {
		// 	const container = this.containerRef.nativeElement;
		// 	this.splineThreeService.initialize(
		// 		container,
		// 		'https://prod.spline.design/bIYBHmJWoLbmwWUk/scene.splinecode'
		// 	);
		// }
		setTimeout(() => {
			window.scroll({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});
		}, 500);
		this.paymentForm = this.formBuilder.group({
			firstname: ['', Validators.required],
			lastname: ['', Validators.required],
			email: [
				'',
				[
					Validators.required,
					Validators.email,
					Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
				],
			],
			contact: ['', Validators.required],
			company: ['', Validators.required],
			customer_message: [''],
			company_address: [''],
			website: [''],
		});
		this.referralForm = this.formBuilder.group({
			referrer_name: ['', Validators.required],
			referrer_email: [
				'',
				[
					Validators.required,
					Validators.email,
					Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
				],
			],
			referrer_phone: ['', Validators.required],
			referred_name: ['', Validators.required],
			referred_email: [
				'',
				[
					Validators.required,
					Validators.email,
					Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
				],
			],
			referred_phone: ['', Validators.required],
			referred_message: [''],
			campaign_id: [''],
			campaign_source: [''],
		});
	}
	get_PageMeta() {
		let obj = { pageName: 'website' };
		this.pageservice.getpageWithName(obj).subscribe((response) => {
			if (response.body.code == 200) {
				this.titleService.setTitle(response?.body.result.meta_title);
				// this.metaTagService.addTags([
				// 	{ name: 'description', content: response?.body.result.meta_description },
				// 	{ name: 'keywords', content: response?.body.result.meta_keywords },
				// ]);
				this.metaTagService.updateTag({
					name: 'description',
					content: response?.body.result.meta_description,
				});
				this.metaTagService.updateTag({
					name: 'keywords',
					content: response?.body.result.meta_keywords,
				});
				this.metaTagService.updateTag({
					rel: 'canonical',
					href: 'https://www.pixtar.ae/website',
				});
			} else if (response.body.code == 400) {
			} else {
			}
		});
	}
	get_AllProjects() {
		const obj = {
			limit: this.currentLimit,
			page: this.currentPage,
		};
		const allowedIds = [
			'674ed82af034ad6b3ba3339e',
			'674ea688f034ad6b3ba330d0',
			'67beed7d15bc16f72f909085',
			'63219d9db7e88c2c1d945874',
		]; // Replace with actual _id values

		this.projectservice.getAllProjects(obj).subscribe((response) => {
			if (response.code === 200) {
				if (response.result && response.result.length > 0) {
					// Filter projects by matching _id values
					const filteredProjects = response.result.filter((project) =>
						allowedIds.includes(project._id)
					);

					// Assign to allprojects
					this.allprojects = [...filteredProjects];
				}
			} else if (response.code === 400) {
				// Handle bad request
			} else {
				// Handle other error codes
			}
		});
	}

	loadMore() {
		this.currentLimit = this.currentLimit + 4;
		this.get_AllProjects();
	}
	sliderInterval: any;
	stopSlider(): void {
		if (this.sliderInterval) {
			clearInterval(this.sliderInterval); // Clears the interval
			// console.log('Slider stopped');
		}
	}

	onMouseLeave() {
		// clearInterval(this.interval);
		if (this.sliderInterval) {
			clearInterval(this.sliderInterval); // Clears the interval
			console.log('Slider stopped');
		}
	}

	onMouseEnter(index: number): void {
		let projectname = this.allprojects[index];
		let images = projectname.project_images;
		let url = this.imagepath;
		let img = document.getElementsByClassName('galleryimg' + index);

		// Function to update the images
		this.sliderInterval = setInterval(() => {
			// setInterval(function () {
			$(img).each(function (index) {
				let newImage =
					images[
						(index + Math.floor(Math.random() * images.length)) % images.length
					];
				$(img).attr('src', url + 'project/' + newImage); // Set new image source
			});
		}, 900); // Update every 3 seconds
		// console.log(`Mouse entered image at index: ${index}`);
	}

	private getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'by pressing ESC';
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'by clicking on a backdrop';
		} else {
			return `with: ${reason}`;
		}
	}

	getStripPayemts(packagename, packageamount, paymentcontent) {
		let obj = { name: packagename, amount: packageamount };
		this.paymentData = obj;
		this.modalReference = this.modalService
			.open(paymentcontent, {
				ariaLabelledBy: 'modal-basic-title',
				windowClass: 'myCustomModalClass2',
			})
			.result.then(
				(result) => {
					this.closeResult = `Closed with: ${result}`;
				},
				(reason) => {
					this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
				}
			);
	}

	public hasError = (controlName: string, errorName: string) => {
		return this.paymentForm.controls[controlName].hasError(errorName);
	};
	public hasEmailError = (form: string, errorName: string) => {
		if (form == 'referrer_email') {
			if (this.referralForm.controls['referrer_email'].value == '') {
				return 'Email is required';
			} else if (
				this.referralForm.controls['referrer_email'].status == 'INVALID'
			) {
				return 'Invalid Email';
			} else {
				return this.referralForm.controls['referrer_email'].hasError(errorName);
			}
		} else if (form == 'referred_email') {
			if (this.referralForm.controls['referred_email'].value == '') {
				return 'Email is required';
			} else if (
				this.referralForm.controls['referred_email'].status == 'INVALID'
			) {
				return 'Invalid Email';
			} else {
				return this.referralForm.controls['referred_email'].hasError(errorName);
			}
		} else {
			if (this.paymentForm.controls['email'].value == '') {
				return 'Email is required';
			} else if (this.paymentForm.controls['email'].status == 'INVALID') {
				return 'Invalid Email';
			} else {
				return this.paymentForm.controls['email'].hasError(errorName);
			}
		}
	};

	public hasReferralError = (controlName: string, errorName: string) => {
		return this.referralForm.controls[controlName].hasError(errorName);
	};

	public hasPhoneNumberError = (type: string, errorName: string) => {
		if (type == 'referrer_phone') {
			if (this.referralForm.controls['referrer_phone'].value == '') {
				return 'Phone Number is required';
			} else if (
				this.referralForm.controls['referrer_phone'].status == 'INVALID'
			) {
				return 'Invalid Phone Number';
			} else {
				return this.referralForm.controls['referrer_phone'].hasError(errorName);
			}
		} else if (type == 'referred_phone') {
			if (this.referralForm.controls['referred_phone'].value == '') {
				return 'Phone Number is required';
			} else if (
				this.referralForm.controls['referred_phone'].status == 'INVALID'
			) {
				return 'Invalid Phone Number';
			} else {
				return this.referralForm.controls['referred_phone'].hasError(errorName);
			}
		} else {
			if (this.paymentForm.controls['contact'].value == '') {
				return 'Phone Number is required';
			} else if (this.paymentForm.controls['contact'].status == 'INVALID') {
				return 'Invalid Phone Number';
			} else {
				return this.paymentForm.controls['contact'].hasError(errorName);
			}
		}
	};

	submitPayment() {
		this.isPaymentSubmitted = true;
		if (this.paymentForm.invalid) {
			return;
		}
		if (this.paymentData) {
			this.paymentData['email'] = this.paymentForm.value.email;
			this.paymentData['customer_name'] = this.paymentForm.value.name;
			this.paymentData['base_url'] = environment.baseUrl;
			this.paymentData['firstname'] = this.paymentForm.value.firstname;
			this.paymentData['lastname'] = this.paymentForm.value.lastname;
			this.paymentData['contact'] =
				this.paymentForm.value.contact.internationalNumber;
			this.paymentData['company'] = this.paymentForm.value.company;
			this.paymentData['company_address'] =
				this.paymentForm.value.company_address;
			this.paymentData['type'] = 'Website';
			this.paymentData['message'] = this.paymentForm.value.customer_message;
			this.paymentData['website'] = this.paymentForm.value.website;
			this.payementservice
				.stripePayments(this.paymentData)
				.subscribe((response) => {
					if (response.body.code == 200) {
						// window.location.href = response.body.url;
						this.isPaymentSubmitted = false;
						localStorage.setItem(
							'stripe-payment-user',
							JSON.stringify(this.paymentData)
						);
						this.paymentForm.reset();
						// window.open(response.body.url, '_blank');
						this.modalService.dismissAll();
						Swal.fire({
							icon: 'success',
							html: "<h1>Thank you</h1> <br> <h6>For submitting you request!<h6> <br> <p> We're thrilled to assist you with your Website Journey!</p> <br><p> One of our team members will contact you shortly to discuss requirements!</p>",
							showConfirmButton: true,
							confirmButtonText: 'Sure! Looking forward',
							customClass: {
								confirmButton: 'success-button',
							},
						});
					} else if (response.body.code == 400) {
					} else {
					}
				});
		}
	}

	closePopUp() {
		this.modalService.dismissAll();
	}

	tabTitle: string = 'Try with us'; // Default title

	changeTabTitle(title: string): void {
		this.tabTitle = title;
	}

	@ViewChild('myVideo') videoElement!: ElementRef;

	ngAfterViewInit() {
		const elem = this.videoElement.nativeElement;
		elem.muted = true; // Ensure the video is muted for autoplay compatibility
		elem.loop = true; // Ensure the video is muted for autoplay compatibility

		// Attempt to autoplay the video when the component initializes
		elem.play().catch((err) => {
			console.log('Autoplay failed, user interaction may be required:', err);
		});
		this.lazyLoader.loadScript('https://unpkg.com/@splinetool/viewer/build/spline-viewer.js')
		.then(() => console.log('Spline viewer loaded'))
		.catch(() => console.error('Failed to load spline viewer script'));
	}

	playInFullscreenWithAudio() {
		const elem = this.videoElement.nativeElement;

		// Unmute the video
		elem.muted = false;

		// Remove controls to avoid interference in fullscreen mode
		elem.removeAttribute('controls');

		// Attempt to play the video and request fullscreen
		elem
			.play()
			.then(() => {
				if (elem.requestFullscreen) {
					elem.requestFullscreen();
				} else if (elem.webkitRequestFullscreen) {
					// Safari
					elem.webkitRequestFullscreen();
				} else if (elem.msRequestFullscreen) {
					// IE11
					elem.msRequestFullscreen();
				} else if (elem.mozRequestFullScreen) {
					// Firefox
					elem.mozRequestFullScreen();
				}
			})
			.catch((err) => {
				console.log('Error entering fullscreen with audio: ', err);
			});
	}

	@HostListener('document:fullscreenchange', ['$event'])
	onFullscreenChange() {
		const elem = this.videoElement.nativeElement;

		if (
			document.fullscreenElement === elem ||
			(document as any).webkitFullscreenElement === elem ||
			(document as any).msFullscreenElement === elem ||
			(document as any).mozFullScreenElement === elem
		) {
			// Video is in fullscreen, attempt to play
			elem.play().catch((err) => {
				console.log('Could not play in fullscreen mode:', err);
			});
		} else {
			// Video exited fullscreen, restore controls and mute the video
			elem.setAttribute('controls', '');
			elem.muted = true;
		}
	}

	openModal() {
		const modalElement = document.getElementById('contactModal');
		this.renderer.addClass(modalElement, 'show');
		this.renderer.setStyle(modalElement, 'display', 'block');
		this.renderer.setStyle(modalElement, 'backgroundColor', 'rgba(0,0,0,0.5)');
		document.body.classList.add('modal-open');
	}

	closeModal() {
		const modalElement = document.getElementById('contactModal');
		this.renderer.removeClass(modalElement, 'show');
		this.renderer.setStyle(modalElement, 'display', 'none');
		document.body.classList.remove('modal-open');
	}

	submitReferral() {
		this.submitted = true;
		if (!this.referralForm.valid) {
			return;
		}
		this.isSubmitting = true;
		this.isLoading = true; // Show loading indicator
		if (
			this.referralForm.value.referrer_email ==
			this.referralForm.value.referred_email
		) {
			this.isEmailSame = true;
			this.isLoading = false;
			return;
		}
		if (
			this.referralForm.value.referrer_phone.internationalNumber ==
			this.referralForm.value.referred_phone.internationalNumber
		) {
			this.isContactSame = true;
			this.isLoading = false;
			return;
		}
		if (this.referralForm.valid) {
			this.referralForm.value['referrer_phone'] =
				this.referralForm.value.referrer_phone.internationalNumber;
			this.referralForm.value['referred_phone'] =
				this.referralForm.value.referred_phone.internationalNumber;
			this.referralService.addReferral(this.referralForm.value).subscribe(
				(response) => {
					if (response.body.code == 200) {
						console.log('Email sent successfully', response);
						this.successMessage =
							'Thank you for referring your friend! We’ve sent an invitation to your friend and will notify you once they join us. Stay tuned for your rewards!';
						this.errorMessage = '';
						this.isSubmitting = false;
						this.isLoading = false; // Hide loading indicator
						this.referralForm.reset();
						this.submitted = false;
						this.closeModal();
						Swal.fire({
							icon: 'success',
							html: '<h1>Thank you</h1> <br> <h6>For referring your friend!!<h6> <br> <p> We’ve sent an invitation to your friend</p> <br><p>We will notify you once they join us. Stay tuned for your rewards!</p>',
							showConfirmButton: true,
							confirmButtonText: 'Sure! Looking forward',
							customClass: {
								confirmButton: 'success-button',
							},
						});
					} else if (response.body.code == 400) {
						this.errorMessage = response.body.message;
						this.isSubmitting = false;
						this.isLoading = false; // Hide loading indicator
						// Auto-hide success message after 3 seconds
						setTimeout(() => {
							this.errorMessage = '';
							this.submitted = false;
						}, 5000);
					}
				},
				(error) => {
					console.error('Error sending email', error);
					this.errorMessage =
						'Failed to send your message. Please try again later.';
					this.isSubmitting = false;
					this.isLoading = false; // Hide loading indicator

					// Auto-hide error message after 3 seconds
					setTimeout(() => {
						this.errorMessage = '';
					}, 5000);
				}
			);
		} else {
			this.errorMessage = 'Please fill in all required fields.';
			this.isSubmitting = false;
			this.isLoading = false; // Hide loading indicator

			setTimeout(() => {
				this.errorMessage = '';
			}, 3000);
		}
	}
}
